import { Button, Tooltip } from '@verantos-dev/shared-components';

export interface CohortBuilderEditModalActionButtonProps {
  id: string;
  displayLabel: string;
  onClick: () => void;
  disabled?: boolean;
  title?: string;
}

export const CohortBuilderEditModalActionButton = ({
  id,
  title,
  displayLabel,
  onClick,
}: CohortBuilderEditModalActionButtonProps) => {
  return (
    <Tooltip id={`cohort-builder-action-button-tooltip-${id}`} title={title} arrow>
      <Button
        id={`cohort-builder-action-button-${id}`}
        displayLabel={displayLabel}
        btnType="secondary"
        startIcon="add"
        onClickHandler={onClick}
      />
    </Tooltip>
  );
};
